import { createAction, props } from '@ngrx/store';

import { ObjectGroupsListItem } from '@store/state/object-groups.state';

export const loadObjectGroups = createAction('[ObjectGroups] Load object groups');
export const loadObjectGroupsSuccess = createAction(
  '[ObjectGroups] Load object groups Success',
  props<{ list: ObjectGroupsListItem[] }>(),
);
export const loadObjectGroupsFailure = createAction(
  '[ObjectGroups] Load object groups Failure',
  props<{ error: string }>(),
);
export const addObjectGroup = createAction(
  '[ObjectGroups] Add Object Group',
  props<{ group: ObjectGroupsListItem }>(),
);
export const updateObjectGroups = createAction(
  '[ObjectGroups] Update object groups',
  props<{ id: string; changes: Partial<any> }>(),
);
export const deleteObjectGroups = createAction(
  '[ObjectGroups] Delete object groups',
  props<{ id: string }>(),
);
